/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useState } from 'react'
import Context from '../context/context'
import { Keyboard } from '@mui/icons-material';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';

const HorizontalTabs = () => {

  const page = window.location.pathname;
  const paths = page.split('/')?.filter(i => i)
  const context = useContext(Context);
  const { selectedMenu, selectMenu, menusCollection, setSeatsState, runningOrders, orderProps, showWarning } = context;
  const [showShortcuts, setShowShortcuts] = useState(null);

  function handleBrandSelection(params) {
    if (orderProps?.lock_brands) return showWarning({
      message: 'Switching Brands Not Allowed',
      classname: 'active-red'
    })
    sessionStorage.setItem('brand', JSON.stringify(params))
    Array.from(document.getElementsByClassName('highlighted-card'))?.forEach(i => i.classList?.remove('highlighted-card'))
    if (+paths[1] === 0) {
      const menu_uuid = JSON.parse(sessionStorage.getItem('seat-menu-details'))?.find(i => i.brand_uuid === params.brand_uuid)?.menu_uuid
      selectMenu({ menu_uuid }, paths[1])
    } else selectMenu({ brand_uuid: params?.brand_uuid }, paths[1])
  }

  function showOccupiedSeats(e) {
    Array.from(document.getElementsByClassName('seats-tabs')).forEach(tab => tab.classList.remove('active'))
    e.currentTarget.classList.add('active')

    const occupiedSeats = runningOrders?.filter(i => i.seat_uuid)?.map(i => i.seat_uuid);
    console.log(occupiedSeats)
    if (occupiedSeats) {
      let DBOpenReq = indexedDB.open('FoodDo', +localStorage.getItem('IDBVersion') || 1);
      DBOpenReq.addEventListener('error', (err) => { console.warn(err) });
      DBOpenReq.addEventListener('success', (ev) => {
        let tx = ev.target.result.transaction('seats', 'readonly');
        let store = tx.objectStore('seats');
        let getReq = store.getAll();

        getReq.onsuccess = (ev) => {
          let seats_collection = ev.target.result
            .filter(i => occupiedSeats?.includes(i.seat_uuid))
            .sort((a, b) => a.seat_sort_order - b.seat_sort_order);
          setSeatsState(seats_collection)
        };
      })
    }
    else { setSeatsState([]) }
  }

  function showUnoccupiedSeats(e) {
    Array.from(document.getElementsByClassName('seats-tabs')).forEach(tab => tab.classList.remove('active'))
    e.currentTarget.classList.add('active')

    const occupiedSeats = runningOrders?.filter(i => i.seat_uuid)?.map(i => i.seat_uuid);
    if (occupiedSeats?.[0]) {
      let DBOpenReq = indexedDB.open('FoodDo', +localStorage.getItem('IDBVersion') || 1);
      console.log('idb collection opened on', window.location.pathname)
      DBOpenReq.addEventListener('error', (err) => { console.warn(err) });
      DBOpenReq.addEventListener('success', (ev) => {
        let tx = ev.target.result.transaction('seats', 'readonly');
        let store = tx.objectStore('seats');

        let getReq = store.getAll();
        getReq.onsuccess = (ev) => {
          let seats_collection = ev.target.result
            .filter(i => !occupiedSeats?.includes(i.seat_uuid))
            .sort((a, b) => a.seat_sort_order - b.seat_sort_order);
          setSeatsState(seats_collection)
        };
      })
    }
    else showAllSeats(e)
  }

  function showAllSeats(e) {
    Array.from(document.getElementsByClassName('seats-tabs')).forEach(tab => tab.classList.remove('active'))
    e.currentTarget.classList.add('active')

    let DBOpenReq = indexedDB.open('FoodDo', +localStorage.getItem('IDBVersion') || 1);
    DBOpenReq.addEventListener('error', (err) => { console.warn(err) });
    DBOpenReq.addEventListener('success', (ev) => {
      let tx = ev.target.result.transaction('seats', 'readonly');
      let store = tx.objectStore('seats');
      let getReq = store.getAll();
      getReq.onsuccess = (ev) => {
        let seats_collection = ev.target.result;
        seats_collection.sort((a, b) => a.seat_sort_order - b.seat_sort_order);
        setSeatsState(seats_collection);
      };
    })
  }

  const page1_shortcuts = [
    {
      op: " Open Menu",
      key: "Enter"
    },
    {
      op: "Payment",
      key: "Ctrl+End"
    }
  ]

  const page2_shortcuts = [
    {
      op: "Increase Qty",
      key: "Enter / +"
    },
    {
      op: "Decrease Qty",
      key: "-"
    },
    {
      op: "Dashboard",
      key: "Shift + D"
    },
    {
      op: "Save",
      key: "Shift + S"
    },
    {
      op: "Save & KOT",
      key: "Shift + K"
    },
    {
      op: "Save & KOT > Confirm & Payment",
      key: "Shift + Q"
    },
    {
      op: "Save > Confirm & Payment",
      key: "Shift + W"
    },
  ]

  const [isMouseOnICO, setIsMouseOnICO] = useState(true)

  return (
    <div className='horizontal-tabs' style={{ marginLeft: page.includes('/page2') ? '0' : '50px' }}>
      {page.includes('/page1') && <>
        <div className="seats-tabs tabs active" onClick={e => showAllSeats(e)}>All</div>
        <div className="seats-tabs tabs" onClick={e => showOccupiedSeats(e)}>Occupied</div>
        <div className="seats-tabs tabs" onClick={e => showUnoccupiedSeats(e)}>Unoccupied</div>
      </>}
      {(page.includes('/page2') && menusCollection?.brands?.[1]) &&
        menusCollection.brands.map(brand => {
          return <div
            key={Math.random()}
            className="tabs brands-tabs"
            onClick={() => handleBrandSelection(brand)}
            style={{ background: selectedMenu?.brand_uuid === brand.brand_uuid ? '#44cd4a' : 'black' }}
          >
            {brand.brand_name}
          </div>
        })}
      {(page.includes("/page1") || page.includes("/page2")) && <Keyboard
        id="keyboard-ico"
        className={page.includes("/page2") ? "page2" : ""}
        onClick={() => setShowShortcuts(!showShortcuts)}
        onMouseEnter={() => setIsMouseOnICO(true)}
        onMouseLeave={() => setIsMouseOnICO(false)}
      />}
      {showShortcuts && <button
        id="keys-shortcuts-container"
        tabIndex={0}
        onBlur={() => !isMouseOnICO && setShowShortcuts(false)}
        autoFocus="true"
      >
        <h4> <Keyboard id="keyboard-ico-inline" />KEY BOARD SHORTCUTS</h4>
        {page.includes('/page1') && page1_shortcuts.map(i => {
          return <div className="shortcut-row">
            <div>{i.op}</div> <ArrowRightAltIcon className="arrow" /> <div>{i.key}</div>
          </div>
        })}
        {page.includes('/page2') && page2_shortcuts.map(i => {
          return <div className="shortcut-row">
            <div>{i.op}</div> <ArrowRightAltIcon className="arrow" /> <div>{i.key}</div>
          </div>
        })}
      </button>}
    </div>
  )
}

export default HorizontalTabs